import BaseApi from "./BaseApi";

export default class ArquivoService {

    static post(cdEventoCadastro, nrOpcao, tipoDocumentoId, files) {
        let command = new FormData();
        command.append("cdEventoCadastro", cdEventoCadastro);
        command.append("nrOpcao", nrOpcao);
        command.append("tipoDocumentoId", tipoDocumentoId);

        for (var i = 0; i < files.length; i++) {
            command.append("files", files[i]);
        }
        return BaseApi.post(`documento/v1`, command);
    }

    static download(command) {
        return BaseApi.post(`documento/v1/downloadDocumento`, command);
    }

    static getTipoDocumentos(cdEventoCadastro, nrOpcao) {
        return BaseApi.get(`documento/v1/getTipoDocumentos/${cdEventoCadastro}/${nrOpcao}`);
    }

    static getDocumentos(cdEventoCadastro, nrOpcao, tipoDocumentoId) {
        return BaseApi.get(`documento/v1/getDocumentos/${cdEventoCadastro}/${nrOpcao}/${tipoDocumentoId}`);
    }

    static downloadDeclaracao(command) {
        return BaseApi.post(`documento/v1/gerarDocumentos/`, command);
    }

    static getTipoDeclaracoes(cdEventoCadastro, nrOpcao) {
        return BaseApi.get(`documento/v1/getTipoDeclaracoes/${cdEventoCadastro}/${nrOpcao}`);
    }
}